export const JOB_TYPES = {
	AVAILABLE: 'available_jobs',
	MATCHES: 'matches_jobs',
	FEATURED: 'featured_jobs',
}

export const FIRST = 12

export const APPLICANT_STATUS = {
	// Interview Request Stage
	INTERVIEW_REQUESTED: 'interview_requested',
	INTERVIEW_REQUEST_APPROVED: 'interview_request_approved',
	INTERVIEW_REQUEST_DECLINED: 'interview_request_declined',

	// Interview Invitation Stage
	RECRUITER_INVITED_TO_INTERVIEW: 'recruiter_invited_to_interview',
	CANDIDATE_DECLINED_INVITE_TO_INTERVIEW: 'candidate_declined_invite_to_interview',
	INTERVIEW_WAITLIST: 'interview_waitlist',

	// Interview Stage
	INTERVIEW_SCHEDULED: 'interview_scheduled',
	INTERVIEW_CANCELED: 'interview_canceled',
	INTERVIEW_COMPLETED: 'interview_completed',

	// Post-Interview Stage
	WAITING_FOR_FEEDBACK: 'waiting_for_feedback',
	NO_OFFER: 'no_offer',

	// Offer Stage
	OFFER_EXTENDED: 'offer_extended',
	OFFER_ACCEPTED: 'offer_accepted',
	OFFER_DECLINED: 'offer_declined',
	INTERVIEW_CONFIRMED: 'interview_confirmed',
	INTERVIEW_2_CONFIRMED: 'interview_2_confirmed',
	INTERVIEW_2_COMPLETED: 'interview_2_complete',
}

// export const ATS_CANCEL_STATUS = [ 'Interview No Show: Candidate', 'Interview No Show: Client']
export const ATS_INVITE_STATUS = ['Interview Invite Sent']
export const ATS_CANCEL_BY_RECRUITER_STATUS = [
	'Interview No Show: Candidate',
	'Interview No Show: Client',
	'Interview Cancelled Client',
	'Interview Canceled by Recruiter',
]

export const ATS_STATUS = {
	INTERVIEW_REQUEST_PEND_APPROVAL: 'interview request pend appr',
	INTERVIEW_REQUEST_APPROVED: 'interview request approved',
	INTERVIEW_REQUEST_DECLINED: 'interview request declined',
	INTERVIEW_WAITLIST: 'interview waitlist',
	INTERVIEW_INVITE_SENT: 'interview invite sent',
	INTERVIEW_INVITE_DECLINED: 'interview invite declined',
	INTERVIEW_INVITE_DECLINED_CANDIDATE: 'interview invite declined: candidate',
	INTERVIEW_INVITE_DECLINED_CND: 'interview invite declined: cnd',
	INTERVIEW_WLST: 'interview wlst',
	INTERVIEW_SCHEDULED: 'interview scheduled',
	INTERVIEW_2_SCHEDULED: 'interview 2 scheduled',
	INTERVIEW_CONFIRMED: 'interview confirmed',
	INTERVIEW_2_CONFIRMED: 'interview 2 confirmed',
	INTERVIEW_CANCELLED_CANDIDATE: 'interview cancelled candidate',
	INTERVIEW_CANCELLED_CND_24: 'interview cancelled cnd 24hrs',
	INTERVIEW_CANCELLED_CLIENT: 'interview cancelled client',
	INTERVIEW_NO_SHOW_CANDIDATE: 'interview no show: candidate',
	INTERVIEW_NO_SHOW_CANDIDATE_2: 'interview no show candidate',
	INTERVIEW_NO_SHOW_CLIENT: 'interview no show: client',
	INTERVIEW_NO_SHOW_CLIENT_2: 'interview no show client',
	INTERVIEW_COMPLETE: 'interview complete',
	INTERVIEW_2_COMPLETE: 'interview 2 complete',
	INTERVIEW_WLST_NOT_AVAILABLE: 'interview wlst - not available',
	INT_RESULTS_REQ: 'int results req',
	INT_RESULTS_REC: 'int results rec',
	WAGE_AMT_REQ: 'wage amt req',
	WAGE_AMT_REC: 'wage amt rec',

	// No Offer Statuses
	NO_OFFER_LANGUAGE_CONCERNS: 'no offer: language concerns',
	NO_OFFER_NOT_QUALIFIED_SKILL: 'no offer: not qualified skill',
	NO_OFFER_INT_PERFORMANCE: 'no offer: int performance',
	NO_OFFER_ENVIRONMENT_FIT: 'no offer: environment fit',
	NO_OFFER_UNIT_CAPACITY: 'no offer: unit capacity',
	NO_OFFER_OTHER: 'no offer: other',
	NO_OFFER_NO_FEEDBACK: 'no offer: no feedback',
	NO_OFFER_SPECIALTY: 'no offer: specialty',
	NO_OFFER_WWHSS_OPP: 'no offer: wwhss opp',
	NO_OFFER_HOSPITAL_TYPE: 'no offer: hospital type',
	NO_OFFER_TIME_TO_OFFER: 'no offer: time to offer',

	// Offer Statuses
	OFFER_EXTENDED: 'offer extended',
	OFFER_ACCEPTED: '02 offer accepted',

	I_140_DOCS_SUBMITTED: '03 i-140 docs submitted',
	ETA_CERTIFIED_BY_DOL: '03b eta certified by dol',
	ETA_9089: '04 eta 9089',
	ETA_FILED_TO_DOL: '04b eta filed to dol',
	PETITION_FILED_TO_USCIS: '05 petition filed to uscis',
	PETITION_APPROVED: '06 petition approved',
	NVC_FEE_BILL_ISSUED: '07 nvc fee bill issued',
	CIVIL_DOCUMENTS_REQUESTED: '08a civil documents requested',
	CIVIL_DOCUMENT_SUBMITTED: '08b civil document submitted',
	DS260: '09a ds260',
	DOCUMENTARILY_QUALIFIED: '09b documentarily qualified',
	EMBASSY_INTERVIEW_NOTICE: '10a embassy interview notice',
	INTERVIEW_COMPLETE_10B: '10b interview complete',
	TRANSITION: '11 transition',
	USA_ARRIVAL: '12 usa arrival',
	PLACEMENT: 'placement',
	PLACED: 'placed',

	// Offer Declined Statuses
	OFFER_DECLINED_WAGE: 'offer declined: wage',
	OFFER_DECLINED_LOCATION: 'offer declined: location',
	OFFER_DECLINED_HOSPITAL_TYPE: 'offer declined: hospital type',
	OFFER_DECLINED_CONTRACT_LENGTH: 'offer declined: contract length',
	OFFER_DECLINED_SIGN_ON_BONUS: 'offer declined: sign on bonus',
	OFFER_DECLINED_IMMIGRATION_TIME: 'offer declined: immigrtn time',
	OFFER_DECLINED_OTHER_AGENCY: 'offer declined: other agency',
	OFFER_DECLINED_UNRESPONSIVE: 'offer declined: unresponsive',
	OFFER_DECLINED_FINANCES: 'offer declined: finances',
	OFFER_DECLINED_PERSONAL: 'offer declined: personal',
	OFFER_DECLINED_ENG_EXAM_REQ: 'offer declined: eng exam req',
	OFFER_DECLINED_BENEFITS: 'offer declined: benefits',
	OFFER_DECLINED_SHIFT: 'offer declined: shift',
	OFFER_DECLINED_SPECIALTY: 'offer declined: specialty',
	OFFER_DECLINED_TIME_TO_OFFER: 'offer declined: time to offer',
	OFFER_DECLINED_OTHER_OPP: 'offer declined: other opp',

	PLACED_TERMINATED_AFTER_GUAR: 'placed-terminated after guar',
	PLACED_TERMINATED_BEFORE_GUAR: 'placed-terminated before guar',
	PLACED_RESIGNED_AFTER_GUAR: 'placed-resigned after guar',
	WD_UNRESPONSIVE: 'wd-unresponsive',
	WD_FINANCIAL_HARDSHIP: 'wd-financial hardship',
	WD_IMMIGRATION_REQ_INCOMPLETE: 'wd-immigration req incomplete',
	WD_ASSIGNMENT_LOCATION: 'wd-assignment location',
	WD_NCLEX_PROGRESS_INSUFFICIENT: 'wd-nclex progress insufficient',
	WD_NCLEX_DIDNT_PASS: `wd-nclex didn't pass`,
	WD_NA_TO_RN: 'wd-na to rn',
	WD_PLACED_RESIGNED_BEFORE_GUAR: 'wd-placed resigned before guar',
	WD_OTHER_AGENCY: 'wd-other agency',
	WD_CLT_CANCELED_WW_CONTRACT: 'wd-clt canceled ww contract',
	WD_CLT_CANCELED_CND_OFFER: 'wd-clt canceled cnd offer',
	WD_PROFESSION_CHANGE: 'wd-profession change',
	WD_IMMIGRATION_DELAYS: 'wd-immigration delays',
	WD_FILING_DELAYS: 'wd-filing delays',
	WD_CONTRACT_CONCERN_LENGTH: 'wd-contract concern length',
	WD_CONTRACT_CONCERN_WAGE: 'wd-contract concern wage',
	WD_PERSONAL_HEALTH_ISSUES: 'wd-personal: health issues',
	WD_PERSONAL_TIMELINE_REASON: 'wd-personal timeline/reason',
	WD_WORK_EXPERIENCE: 'wd-work experience',
	WD_EDUCATION_NON_BSN: 'wd-education non-bsn',
	WD_PRE_EMPLOYMENT_ASSESSMENT: 'wd-pre employment assessment',
	WD_NO_PREMIUM_PROCESSING: 'wd-no premium processing',
	WD_OTHER: 'wd-other',
}

export const DENY_OPEN_JOB_DETAIL = [
	ATS_STATUS.PLACED_TERMINATED_AFTER_GUAR,
	ATS_STATUS.PLACED_TERMINATED_BEFORE_GUAR,
	ATS_STATUS.PLACED_RESIGNED_AFTER_GUAR,
	ATS_STATUS.WD_UNRESPONSIVE,
	ATS_STATUS.WD_FINANCIAL_HARDSHIP,
	ATS_STATUS.WD_IMMIGRATION_REQ_INCOMPLETE,
	ATS_STATUS.WD_ASSIGNMENT_LOCATION,
	ATS_STATUS.WD_NCLEX_PROGRESS_INSUFFICIENT,
	ATS_STATUS.WD_NCLEX_DIDNT_PASS,
	ATS_STATUS.WD_NA_TO_RN,
	ATS_STATUS.WD_PLACED_RESIGNED_BEFORE_GUAR,
	ATS_STATUS.WD_OTHER_AGENCY,
	ATS_STATUS.WD_CLT_CANCELED_WW_CONTRACT,
	ATS_STATUS.WD_CLT_CANCELED_CND_OFFER,
	ATS_STATUS.WD_PROFESSION_CHANGE,
	ATS_STATUS.WD_IMMIGRATION_DELAYS,
	ATS_STATUS.WD_FILING_DELAYS,
	ATS_STATUS.WD_CONTRACT_CONCERN_LENGTH,
	ATS_STATUS.WD_CONTRACT_CONCERN_WAGE,
	ATS_STATUS.WD_PERSONAL_HEALTH_ISSUES,
	ATS_STATUS.WD_PERSONAL_TIMELINE_REASON,
	ATS_STATUS.WD_WORK_EXPERIENCE,
	ATS_STATUS.WD_EDUCATION_NON_BSN,
	ATS_STATUS.WD_PRE_EMPLOYMENT_ASSESSMENT,
	ATS_STATUS.WD_NO_PREMIUM_PROCESSING,
	ATS_STATUS.WD_OTHER,
]

export const PWD_STATUS = {
	DETERMINED: 'Determined',
	IN_PROGRESS: 'In Process',
}

export const NOF_STATUS = {
	VALID: 'Valid',
	INVALID: 'Invalid',
}
